import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const badgeVariants = cva(
  'inline-flex items-center gap-1 rounded-vt-pill px-2.5 py-0.5 text-[11px] font-medium leading-none transition-colors duration-vt',
  {
    variants: {
      variant: {
        default: 'bg-vt-secondary-100 text-vt-text ring-1 ring-inset ring-vt-border',
        info: 'bg-vt-info-100 text-vt-info ring-1 ring-inset ring-vt-info/15',
        warn: 'bg-vt-warn-100 text-vt-warn ring-1 ring-inset ring-vt-warn/15',
        ok: 'bg-vt-safe-100 text-vt-safe ring-1 ring-inset ring-vt-safe/15',
        alert: 'bg-vt-alert-100 text-vt-alert ring-1 ring-inset ring-vt-alert/15',
        muted: 'bg-vt-surface-2 text-vt-text-muted ring-1 ring-inset ring-vt-border'
      }
    },
    defaultVariants: { variant: 'default' }
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, ...props }: BadgeProps): JSX.Element {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}
